import { Component, computed, inject } from '@angular/core';
import { AppMenu } from './app.menu';
import { RouterModule } from '@angular/router';
import { AppTopbar } from '@app/layout/components/app.topbar';
import { CommonModule } from '@angular/common';
import { ClientConfigService } from '../service/client-config/client-config.service';
import { ClientContextSelectorComponent } from '@modules/clients/pages/client-detail/components/client-context-selector/client-context-selector.component';
import { BaseSidebar } from './base-sidebar';

@Component({
  selector: '[app-sidebar]',
  standalone: true,
  imports: [CommonModule, AppMenu, RouterModule, AppTopbar, ClientContextSelectorComponent],
  template: ` <div
    class="layout-sidebar"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <div class="sidebar-header">
      <a class="logo" [routerLink]="['/']">
        <img class="logo-image" [src]="logo()" alt="logo" />
        <span class="app-name text-4xl font-semibold leading-normal"></span>
      </a>
      <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
      <button
        class="layout-sidebar-close"
        type="button"
        aria-label="Cerrar menú"
        (click)="closeMenu()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div #menuContainer class="layout-menu-container">
      <d2d-client-context-selector />
      <div app-menu></div>
    </div>
    <div app-topbar *ngIf="isHorizontal() && !layoutService.isMobile()"></div>
  </div>`,
})
export class AppSidebar extends BaseSidebar {
  private readonly clientConfigService = inject(ClientConfigService);

  logo = computed(() => {
    const cfg = this.clientConfigService.configSignal();
    return cfg?.logo_url ?? './icons/logo-d2d.svg';
  });
}
